import { has as xHas } from 'lodash';

export class ViewPoint extends DOMPoint {

    constructor(x, y) {
        super(x, y);

        this._id = 0;
        this._name = "";
        this._has_tags = false;
    }

    static make(from) {
        const inst = new ViewPoint(0, 0);

        // if (xHas(from, "x"))
            inst.x = from.x;
        // if (xHas(from, "y"))
            inst.y = from.y;
        // if (xHas(from, "id"))
            inst.id = from.id;
        // if (xHas(from, "name"))
            inst.name = from.name;
            inst.has_tags = from.has_tags ?? false;

        return inst;
    }

    get id() { return this._id; }

    set id(value) { this._id = value; }

    get name() { return this._name; }

    set name(value) { this._name = value; }

    get has_tags() { return this._has_tags; }

    set has_tags(value) { this._has_tags = value; }
}